<template>
  <div class="ui label" :class="{ green: !f.Idling }">
    <i class="icon" :class="{ running: !f.Idling, bed: f.Idling }"></i>
    <router-link :to="{ name: 'app-flow', params: { appId, flowId: f.ID } }" class="detail">{{
      f.Name
    }}</router-link>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import Vue from 'vue'
import { Estero } from 'services'
import _ from 'lodash'

// TODO lookup the app-id for the flow to produce a working link

export default {
  name: 'running-flow',
  props: ['flow'],

  computed: {
    f() {
      if (this.flow) return { ...JSON.parse(this.flow), Idling: false }
      return { Name: this.$t('NO_RUNNING_FLOW'), Idling: true }
    },

    appId() {
      const flow = _.find(this.$store.state.flow.items, f => this.flow && f.id === this.flow.ID)
      if (flow) return flow.application
      return ''
    }
  }
}
</script>
